import React from "react";
import {MainLeftTitle } from '../../../_uiComponents/WrapperComponents'
import CreateUsersForm from "./forms/CreateUsersForm";

export const CreateUsersWrapper = () => {
    return (
        <>
            <div className='sbt-data-grid__wr'>
                <MainLeftTitle title="Create Users">
                    </MainLeftTitle>
                <CreateUsersForm/>
            </div>
        </>
    )
}